export default __webpack_public_path__ + "static/media/pendServico.ffdd69b0.svg";